module.exports = __webpack_public_path__ + "img/dj.1751d6cd.svg";